module.exports = __webpack_public_path__ + "static/assets/8dfe8bfde1660c5251de032baaf4939c.png";